import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { isType } from './isType'

export const isAmazonMaturityRatingBadge = (
  ratingBadge?: WpsRuntime.atv.wps.RatingBadgeProps
): ratingBadge is WpsRuntime.atv.wps.AmazonMaturityRatingBadge =>
  isType(ratingBadge, 'atv.wps#AmazonMaturityRatingBadge')

export const isRegulatoryRatingBadge = (
  ratingBadge?: WpsRuntime.atv.wps.RatingBadgeProps
): ratingBadge is WpsRuntime.atv.wps.RegulatoryRatingBadge =>
  isType(ratingBadge, 'atv.wps#RegulatoryRatingBadge')

export const isLocalRatingBadge = (
  ratingBadge?: WpsRuntime.atv.wps.RatingBadgeProps
): ratingBadge is WpsRuntime.atv.wps.LocalRatingBadge =>
  isType(ratingBadge, 'atv.wps#LocalRatingBadge')

export const shouldShowAmrDescription = (
    amr: WpsRuntime.atv.wps.AmazonMaturityRatingBadge
): boolean => amr.id !== 'all'
